module.exports = __webpack_public_path__ + "img/138.0f23e392.jpg";